import React, {Component} from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Field, reduxForm, reset, submit, stopSubmit,setSubmitFailed} from 'redux-form';
import NoContentAdded, {NO_REVIEWER} from 'NoContentAdded';
import Pagination from "react-js-pagination";
import {IMAGE_PATH, itemCount, COMMON_FAIL_MESSAGE} from 'Constants';
import { showError, showSuccess } from 'ReduxErrorBar';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';
import LocaleStrings from 'Languages';
import {openReviewerPassowrdModal,sendLoginCredentials} from 'ProposalAction';
import { changePassword } from 'SettingActions';


class ChangePassword extends Component{

    constructor(props){
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.state = {loading:false};
    }

    componentDidMount() {
        
    }
    
    closeModal() {
        this.props.openReviewerPassowrdModal(false,'');
    }

    onSubmitForm = (values) => {

        let {showChangePasswordReviewer} = this.props;
        let email = showChangePasswordReviewer && showChangePasswordReviewer.reviewer && showChangePasswordReviewer.reviewer.email ? showChangePasswordReviewer.reviewer.email : '';
        var valuesToSubmit={...values,email:email};

        let mailData = {}
        mailData.password = values.new_password;
        let appuserid = showChangePasswordReviewer && showChangePasswordReviewer.reviewer && showChangePasswordReviewer.reviewer.appuserid ? showChangePasswordReviewer.reviewer.appuserid : '';
        mailData.appuserid = appuserid;
        this.setState({loading:true});
        this.props.changePassword(this.props.session,valuesToSubmit,(response)=>{

            if(response.error){

                this.setState({loading:false});
                this.props.showError(COMMON_FAIL_MESSAGE);    
            }
            else{

                this.props.sendLoginCredentials(this.props.session,mailData,(feedback) => {

                    if (feedback.success === 0) {
                        this.setState({loading:false});
                        this.props.showError(COMMON_FAIL_MESSAGE);    
                    }
                    else{
                        this.props.reset();
                        this.setState({loading:false});
                        this.props.showSuccess(LocaleStrings.proposal_reviewer_pwd_send);
                        this.closeModal();
                    }
    
                });

            }

        });     
        
    }

    renderField(field){
        var { meta: { touched, error } } = field;
        var className = `form-group login-element ${(touched && error) ? 'has-danger' : ''}`;
        return (
          <div className={className}>
            <label>{field.label}</label>
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
            />
            <div className="text-help">
              { touched ? error : ''}
            </div>
          </div>
        );
    }
   
    render() {
        var {handleSubmit, pristine, reset, submitting, invalid,showChangePasswordReviewer} = this.props;
       
        return (
                    <div>
                        
                        <Modal className="modal-container" enforceFocus={false} show={showChangePasswordReviewer.showModal === true ? true : false} animation={true} >                        
                            
                            <Modal.Header>
                                <div className="import-modal-title">{LocaleStrings.reset_password}</div>
                                <button type="button" className="i-custom-cross-popup pull-right" onClick={() => this.closeModal()}>
                                    <img className="i-custom-small" src="../../style/images/custom-icons/cross-black.png" />
                                </button>
                            </Modal.Header>
                            <form onSubmit={handleSubmit(this.onSubmitForm)}>
                                <Modal.Body>
                               
                                   
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12">
                                            <div className='form-group row'>
                                                <label className='control-label-top col-sm-12'>
                                                    {LocaleStrings.user_form_label_email}<span className="label-mandatory">*</span>
                                                </label>
                                                <div className='col-sm-12 col-sm-offset-0' style={{padding:'6px 14px',fontWeight:'bold',color:'#2676ea'}}>
                                                    {showChangePasswordReviewer && showChangePasswordReviewer.reviewer && showChangePasswordReviewer.reviewer.email ? showChangePasswordReviewer.reviewer.email : ''}
                                                </div>
                                            </div>
                                           
                                            <Field
                                                name="new_password"
                                                label={LocaleStrings.password_setting_form_label_new_password}
                                                placeholder={LocaleStrings.password_setting_form_ph_new_password}
                                                type="password"
                                                component={this.renderField}
                                            />
                                            <Field
                                                name="repeat_new_password"
                                                label={LocaleStrings.password_setting_form_label_repeat_password}
                                                placeholder={LocaleStrings.password_setting_form_ph_repeat_password}
                                                type="password"
                                                component={this.renderField}
                                            />

                                        </div>
                                    </div>
                         
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button className="btn btn-custom-white" bsStyle="" onClick={this.closeModal}>{LocaleStrings.button_close}</Button>
                                    <Button className="btn btn-custom-blue ml-10" bsStyle="" loading={this.state.loading} disabled={ pristine || invalid || submitting } type="submit">{LocaleStrings.reviewer_change_and_send_button}</Button>
                                </Modal.Footer>
                            </form>
                        </Modal>
                        
                    </div>
                );
            }
    }
function mapStateToProps(state) {

    return {
        session: state.session,
        showChangePasswordReviewer:state.showChangePasswordReviewer,
  
    };
}
    
function validate(values) {
    // console.log('values',values);
    var errors = {};
    if(!values.new_password) {
        errors.new_password = LocaleStrings.password_setting_form_validation_new_password_required;
    }
    
    if(values.new_password && !values.repeat_new_password){
       errors.repeat_new_password = LocaleStrings.password_setting_form_validation_repeat_password_required;
    }
    
    if(values.new_password && values.repeat_new_password){
        if(values.new_password !== values.repeat_new_password){
            errors.repeat_new_password=LocaleStrings.password_setting_form_validation_repeat_old_password_not_match;
        }
    }
    return errors;
}
    
export default connect(mapStateToProps, {openReviewerPassowrdModal,showError, showSuccess,sendLoginCredentials,changePassword})(reduxForm({
    validate,
    form:'ProposalForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
}) (ChangePassword));